<template>
    <ion-toolbar>
      <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button @click="skip" class="pill next-pill-button">
          <span>Skip</span>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  
    <div class="main_wrapper ion-padding">
      <!-- <div class="page_title">
        {{ pageText[userRole].pageTitle }}
      <el-progress v-if="userRole === 'pharmacy'" class="progress" :percentage="55" :show-text="false" color="#2463FF" />
      </div> -->
      <div class="container onboarding">
        <div class="auth-header">
          <div class="auth-heading">
            <h1>{{ pageText[userRole].pageTitle }}</h1>
            <p class="auth-subtext">{{ pageText[userRole].formText }}</p>
          </div>
          <div class="brand-icon">
            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
          </div>
        </div>
        <el-form :model="formsData.userForm" :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="save('userForm')">
        
            <el-form-item label="Primary Contact" prop="additionalName1">
              <el-input v-model="formsData.userForm.additionalName1.value" autocomplete="off" placeholder="Name"
                :maxlength="50" @keyup="
                  formsData.userForm.additionalName1.value = $event.target.value
                " @blur="checkFormValidation('userForm', true, 'additionalName1')"></el-input>
            </el-form-item>
            <!-- <el-form-item label="Primary Contact’s Email Address" prop="additionalEmail1" :required="true">
                <el-input
                type="email"
                v-model="formsData.userForm.additionalEmail1.value"
                placeholder="email@gmail.com"
                @blur="checkFormValidation('userForm', true, 'additionalEmail1')"
                ></el-input>
            </el-form-item> -->
            <el-form-item label="Primary Contact’s Phone Number" prop="additionalPhone1" :required="true" class="is-no-asterisk">
              <div class="el-input">
                <vue-tel-input class="el-input__inner" :value="formsData.userForm.additionalPhone1.valueFormatted"
                  v-model="formsData.userForm.additionalPhone1.value" v-bind="{ mode: 'international' }"
                  :preferredCountries="[$filters.vueTelInput()]" :autoDefaultCountry="false" @input="onPhoneInput1" @blur="handleBlur"></vue-tel-input>
              </div>
            </el-form-item>
         
          <el-form-item class="button_submit mb0 mt-auto">
            <el-button class="submit" type="blue" @click="save('userForm')" :disabled="formsData.userForm.disabled">
              Continue
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </template>
  
  <script>
  import { onMounted, inject, defineAsyncComponent,  getCurrentInstance} from "vue";
  
  import { addIcons } from "ionicons";
  import { arrowBackOutline } from "ionicons/icons";
  addIcons({
    "arrow-back-outline": arrowBackOutline,
  });
  import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
  
  import { useStore } from "vuex";
  
  import { useRouter, useRoute } from "vue-router";
  import formHooks from "@/hooks/form/form";
  import formValidate from "@/hooks/form/validate/validate";
  import SvgIcon from '@/components/Svg/SvgIcon.vue'; 
  const VueTelInput = defineAsyncComponent(() =>
    import("@/components/Vendor/vue-tel-input/components/vue-tel-input.vue")
  );
  export default {
    components: {
      IonToolbar,
      IonButton,
      IonButtons,
      IonIcon,
      VueTelInput,
      SvgIcon
    },
    setup() {
      const $store = useStore();
      const $router = useRouter();
      const $route = useRoute();
      const setPageClassGlobal = inject(["setPageClassGlobal"]);
      const instance = getCurrentInstance();
  
      const userData = $store.getters.GET_USER_DATA;
      const userRole = userData.role;
  
      const pageText = {
        pharmacy: {
          pageTitle: "Company/Employer Contacts",
          formText: `Add key company/employer contacts below. The contact details will be displayed to ${instance?.appContext.config.globalProperties.$filters.systemLocumName(false, false) }s who confirm a booking with your company/employer`,
        },
      };
  
      const formsDataArray = {
        userForm: {},
      };
  
      let dataArray = {};
  
      dataArray = {
        additionalName1: {
          value: "",
  
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "employerAdditionalName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        additionalPhone1: {
          ref: {},
          value: "",
          valueFormatted: "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "employerMobileNumber",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
          errors: null,
        },
        // additionalEmail1: {
        //   value: "",
        //   resetValue: true,
        //   validators: [
        //     {
        //       validator: (rule, formField, callback) => {
        //         formValidate.validate(
        //           rule,
        //           formField,
        //           "additionalEmail1",
        //           callback,
        //           setFormValidation
        //         );
        //       },
        //       trigger: ["blur", "enter"],
        //     },
        //   ],
        // },
      };

      const onPhoneInput1 = (value, phoneObject) => {
        if (!value.target) {
          formsData.userForm.additionalPhone1.ref.phoneObject = phoneObject;
        }
        formsData.userForm.additionalPhone1.valueFormatted = value.target
          ? value.target.value
          : value;
        formsData.userForm.additionalPhone1.value =
          formsData.userForm.additionalPhone1.ref.phoneObject.number || null;
        
          checkFormValidation("userForm", false, "additionalPhone1");
   
         
        
      };

      Object.assign(formsDataArray.userForm, dataArray);
  

      const handleBlur = () => {
        checkFormValidation("userForm", true, "additionalPhone1"); 
        };

      const goBack = async() => {
        const back = await $store.dispatch("getAuthPageBack");
        $router.push({
            name: back,
        });
      };
  
      const goNext = () => {
       $router.push({
            name: "auth_address",
          });
      };
  
      const skip = () => {
        $store.dispatch("addAuthPageBack", $route.name);
        goNext();
      };
  
      const save = (formName) => {
        formsRefs[formName].value.validate((valid) => {
          if (valid) {
            (async () => {
              try {
                await $store.dispatch("SAVE_USER_DATA", getFormValues(formName));
                goNext();
              } catch (error) {
                console.log("error submit!!");
              }
            })();
          } else {
            setFormValidation(formName, false, false);
            console.log("error submit!!");
            return false;
          }
        });
      };
  
      onMounted(() => {
          setPageClassGlobal("global_auth_page");
          setFormRefs();
        //   formsRefs.userForm.value.$el[0].focus();
          checkFormValidation("userForm", false);
      });
  
      const {
        checkFormValidation,
        setFormValidation,
        getFormValues,
        setFormRefs,
        formsData,
        formsRefs,
      } = formHooks(formsDataArray);
  
      return {
        formsData,
        goBack,
        save,
        skip,
        userRole,
        pageText,
        onPhoneInput1,
        handleBlur
      };
    },
  };
  </script>
  